const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://htimmigrationsolutions.com/api';
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

export default API_BASE_URL;
